import { configService } from "@/infrastructure/services/ConfigService";
export function buildPublicFormUrl(publicSlug) {
    const baseUrl = configService.publicFormBaseUrl;
    if (!baseUrl) {
        return null;
    }
    const slug = (publicSlug ?? "").trim();
    if (slug === "") {
        return null;
    }
    return `${baseUrl.replace(/\/+$/, "")}/forms/${encodeURIComponent(slug)}`;
}
export function isPublicFormLinkActive(status) {
    return status === "Published";
}
/**
 * Must stay byte-for-byte the markup the backend `IframeSnippetBuilder::build` emits for the same
 * well-formed slug (same attributes, same order, same attribute escaping): a snippet copied before
 * publication and the one returned by the publish response must yield the same iframe.
 */
export function buildEmbedSnippet(publicSlug) {
    const url = buildPublicFormUrl(publicSlug);
    if (url === null) {
        return null;
    }
    return `<iframe src="${escapeAttribute(url)}" width="100%" height="800" frameborder="0" loading="lazy"></iframe>`;
}
// Mirrors PHP `htmlspecialchars($value, ENT_QUOTES | ENT_HTML5)` — `'` becomes `&apos;` under
// ENT_HTML5, not `&#039;`.
function escapeAttribute(value) {
    return value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&apos;");
}
